import { inject, Injectable } from '@angular/core'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesProjectContractsListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class ProjectContractsApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: ArchivesProjectContractsListParams) {
    return this.archivesService.projectContracts(params)
  }
}
